<template>
  <div
    v-if="data && $route.name === 'Room'"
    class="map-container"
    :class="[
      {'black': switchFloorsMap || onBorderContract || isHotspotOpen}
    ]"
  >
    <div class="footer-gradient"></div>
    <transition name="fade-map" mode="out-in" appear>
      <div v-show="showFloorsMap" class="map-open">
        <ButtonClose v-show="showFloorsMap" @click="closeMap" />
        <MapFloorsList @onFloorClick="onFloorClick" />
        <v-container fluid>
          <transition name="fade-map" mode="out-in" appear>
            <v-row :key="currentFloor" align-sm="center" class="map-content ma-0">
              <v-col cols="12" md="6" offset-md="1">
                <div
                  v-show="currentFloor === floor._slug"
                  v-for="(floor, index) in data.items"
                  :key="index"
                  class="map-floor"
                >
                  <MapRoomDot
                    v-show="(room.positionInMap.indexOf('hide') === -1 || currentRoom === room.roomName._slug)"
                    v-for="(room, rindex) in floor.rooms"
                    :key="rindex"
                    :room="room"
                    :floor="floor"
                    :currentRoom="currentRoomOver"
                    :isActive="showFloorsMap && currentFloor === floor._slug"
                    :visitedRooms="visitedRooms"
                    @roomOver="(room) => currentRoomOver = room"
                    @roomOut="(room) => currentRoomOver = room"
                    @roomClick="onChangeRoom"
                  />
                  <img :src="'/media/' + floor.map.id" :class="('floor-' + index)" />
                  <ArchetypesSvg v-show="currentFloor !== 'piano-0'" class="archetypes-logo" />
                </div>
              </v-col>
              <v-col cols="12" md="4" class="pl-md-10">
                <div
                  v-for="(room, rindex) in currentFloorObject"
                  :key="rindex + room.roomName._slug"
                  @click="onChangeRoom(currentFloor, room.roomName)"
                  @mouseover="currentRoomOver = room.roomName._slug"
                  @mouseout="currentRoomOver = ''"
                  :style="{ transitionDelay: 0.2 + (0.1 * rindex) + 's' }"
                  class="link my-4"
                  :class="{ 'active': (currentRoomOver.indexOf(room.roomName.enTitle) > -1) }"
                >
                  <h3>{{ room.roomName[$language.current + 'Title'] }}</h3>
                </div>
              </v-col>
            </v-row>
          </transition>
        </v-container>
      </div>
    </transition>
    <Footer
      @onMapFloorClick="openMap"
      :showFloorsMap="switchFloorsMap"
      :currentRoomOver="currentRoomOver"
      :currentFloorOver="currentFloor"
    />
  </div>
</template>

<script>
import ListFloor from '@/graphql/ListFloor.gql'

import Footer from '../organisms/Footer.vue'
import ButtonClose from '../atoms/ButtonClose.vue'
import MapFloorsList from '../atoms/MapFloorsList.vue'
import MapRoomDot from '../atoms/MapRoomDot.vue'
import ArchetypesSvg from '@/assets/svg/logo-archetypes.svg'

export default {
  name: 'FloorMap',
  components: {
    ButtonClose, MapRoomDot, MapFloorsList, Footer, ArchetypesSvg
  },
  apollo: {
    Floors: {
      query: ListFloor,
      variables () {
        return {
          sortOn: '_slug',
          descending: false
        }
      },
      async result () {
        this.$root.floors = this.Floors.items
        this.$root.floors.sort((a, b) => {
          if (a._slug < b._slug) { return -1 }
          if (a._slug > b._slug) { return 1 }
          return 0
        })
        this.data = this.Floors
      }
    }
  },
  mounted () {
    this.$events.on('onLogoClick', () => { this.closeMap('logo') })
    this.$events.on('onBorderExpanded', (e) => { this.onBorderContract = e })
    this.$events.on('onHotspotOpen', () => { this.isHotspotOpen = true })
    this.$events.on('onHotspotClose', () => { this.isHotspotOpen = false })
    if (this.$route.params.floor) {
      this.currentFloor = this.$route.params.floor
    }
    this.currentRoom = this.$route.params.roomName
  },
  data () {
    return {
      data: null,
      showFloorsMap: false,
      switchFloorsMap: false,
      isHotspotOpen: false,
      currentFloor: '',
      onBorderContract: false,
      currentRoom: null,
      currentRoomOver: '',
      visitedRooms: []
    }
  },
  computed: {
    currentFloorObject () {
      let floor = this.data.items[0].rooms

      if (this.currentFloor !== '') {
        for (let i = 0; i < this.data.items.length; i++) {
          const fl = this.data.items[i]
          if (fl._slug === this.currentFloor) {
            // floor = fl.rooms
            // only put room with unique name
            floor = []
            const roomsNames = []
            for (let k = 0; k < fl.rooms.length; k++) {
              const room = fl.rooms[k]
              if (room.positionInMap.indexOf('hide') === -1 && (roomsNames.length === 0 || !roomsNames.includes(room.roomName.enTitle))) {
                floor.push(room)
                roomsNames.push(room.roomName.enTitle)
              }
            }
          }
        }
      }
      return floor
    }
  },
  methods: {
    onFloorClick (floor) {
      this.currentFloor = floor
    },
    onChangeRoom (floor, room) {
      if (this.$route.params.roomName !== room._slug) {
        let eventAction = ''

        if (floor === 'piano-0') eventAction = 'Ground Floor (Gucci Garden Boutique and Bookstore)'
        else if (floor === 'piano-1') eventAction = 'Galleria 1° Floor (Gucci Garden Archetypes - 1)'
        else if (floor === 'piano-2') eventAction = 'Galleria 2° Floor (Gucci Garden Archetypes - 2)'

        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'generic_event',
            eventCategory: 'Clicks on Maps Button',
            eventAction,
            eventLabel: room.enTitle || room.title
          })
        }

        this.closeMap()

        if (!this.visitedRooms.includes(room)) {
          this.visitedRooms.push(room)
        }

        this.$router.push(
          {
            name: 'Room',
            params: {
              floor: floor,
              roomName: room._slug
            }
          }
        )
      }
    },
    openMap () {
      this.switchFloorsMap = true
      this.showFloorsMap = true
      this.$events.emit('onMapOpen')
    },
    closeMap (type) {
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'generic_event',
          eventCategory: type === 'logo' ? 'Clicks on Maps Button' : 'Clicks on Close Map Button',
          eventAction: type === 'logo' ? 'Clicks on Gucci Garden Logo' : 'Clicks on Close Map',
          eventLabel: ''
        })
      }
      this.showFloorsMap = false
      this.switchFloorsMap = false
      this.$events.emit('onMapClose')
    }
  },
  watch: {
    $route (to, from) {
      this.currentFloor = this.$route.params.floor
      this.currentRoom = to.params.roomName
    }
  }
}
</script>

<style lang="scss">
.fade-map-enter-active,
.fade-map-leave-active {
  transition: all 0.2s $ease-in-out-quad;
}

.fade-map-enter,
.fade-map-leave-to {
  opacity: 0;
}

.footer-gradient {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  height: 25%;
  pointer-events: none;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.85) 0%, rgba(0, 0, 0, 0) 100%);
}

/* stylelint-disable */
.map-container {
  color: $c-white;

  &.black {
    color: $c-black;

    .icon-social {
      opacity: 0.6;

      &:hover {
        opacity: 1;

        path {
          fill: $c-white;
        }
      }

      path {
        fill: $c-black
      }
    }
  }
}
/* stylelint-enable */

.map-open {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background-color: $c-pink;
  overflow-y: auto;

  .container {
    height: 100%;

    @include breakpoint ('sm-only') {
      height: 80%;
    }

    @include breakpoint ('xs-only') {
      height: auto;
    }
  }
}

.map-content {
  height: 100%;
}

.map-floor {
  position: relative;

  img {
    width: 100%;
    height: auto;

    &.floor-0 {
      @include breakpoint ('sm-only') {
        min-height: 357px;
      }

      @include breakpoint ('xs-only') {
        min-height: 182px;
      }
    }

    &.floor-1 {
      @include breakpoint ('sm-only') {
        min-height: 360px;
      }

      @include breakpoint ('xs-only') {
        min-height: 184px;
      }
    }

    &.floor-2 {
      @include breakpoint ('sm-only') {
        min-height: 460px;
      }

      @include breakpoint ('xs-only') {
        min-height: 234px;
      }
    }
  }

  .archetypes-logo {
    width: 225px;
    height: auto;
    position: fixed;
    top: 65%;
    left: 45%;

    @include breakpoint ('lg-only') {
      width: 215px;
      top: 67%;
      left: 40%;
    }

    @include breakpoint ('md-only') {
      width: 155px;
      top: 65%;
      left: 40%;
    }

    @include breakpoint ('sm-only') {
      position: absolute;
      width: 215px;
      top: unset;
      left: unset;
      right: 20px;
      bottom: 0;
    }

    @include breakpoint ('xs-only') {
      position: absolute;
      width: 150px;
      top: unset;
      left: unset;
      right: 20px;
      bottom: -20px;
    }
  }
}

.link {
  cursor: pointer;

  h3 {
    font-size: 30px;
    font-weight: normal;
    color: $c-black;
    opacity: 0.6;
    line-height: 1;
    transition: all 0.2s $ease-in-out-quad;

    @include breakpoint ('lg-and-down') {
      font-size: 22px;
    }

    @include breakpoint('xs-only') {
      font-size: 18px;
    }
  }

  &.active,
  &:hover {
    h3 {
      color: $c-black;
      opacity: 1;
    }
  }
}
</style>
